import { Api } from '@/services/Api';

export default {
    /*  1. Get all data By  Critirea */
    GetSettingOrganizationByCriteria(body = { keyword: '' }) {
        return Api().post('/SettingOrganization/GetSettingOrganizationByCriteria', body);
    },

    /*  1. Get all data By Key Word */
    getSettingOrgs(keyword = '') {
        return Api().get(`/SettingOrganization${keyword ? '?Keyword=' + keyword : ''}`);
    },

    /*  1. Get one column */
    getSettingOrg(id) {
        return Api().get(`/SettingOrganization/${id}`);
    },

     /*  1. Create one column */
    saveSettingOrg(body) {
        return Api().post(`/SettingOrganization`, body);
    },

     /*  1. Delete one column or More */
    deleteSettingOrgs(settingOrgs) {
        return Api().post(`/SettingOrganization/DeleteSettingOrganization`, settingOrgs);
    },

/*  1. Post one column or More */
    postSettingOrgs( settingOrgs) {
        return Api().post(`/SettingOrganization/PostSettingOrganization`, settingOrgs);
    },

    /*  1. Post one column or More */
    GetSettingOrganizationByUserId( ) {
        return Api().get(`/SettingOrganization/GetSettingOrganizationByUserId`);
    },
}